export default __webpack_public_path__ + "static/media/VSB_SNHL_IND_01.022362a3.jpg";